import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEraserLasso = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 61.57,
			d: "M1680.31 3258.91h-221.49v-558.44h313.79v472.86z",
			transform: "rotate(45 5030.847 535.644)scale(1.12441 1.21262)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 74.83,
			d: "m1857.96 2729.3 259.31 259.32",
			transform: "matrix(1.04327 -.08114 -.08114 1.04327 -1348.91 -2293.08)"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M394.5 693.87c19.9.34 35.7 16.74 35.4 36.61-.4 19.87-16.8 35.72-36.6 35.38-12.3-.21-24.1-.25-35.7-.11-19.9.23-36.2-15.71-36.4-35.58-.2-19.86 15.7-36.18 35.6-36.41 12.2-.15 24.8-.11 37.7.11m-190 13.44c19.5-3.69 38.3 9.17 42 28.7 3.7 19.52-9.2 38.36-28.7 42.05-24.9 4.71-46.4 10.6-64.4 17.55-18.5 7.18-39.4-2.03-46.5-20.56-7.2-18.52 2-39.39 20.5-46.57 21.5-8.32 47.2-15.53 77.1-21.17M50.3 889.92c-11.7-16.1-8.1-38.62 8-50.27 16.1-11.64 38.7-8.02 50.3 8.07 8.9 12.27 24.1 24.05 45 35.84 17.3 9.78 23.4 31.75 13.6 49.05s-31.7 23.42-49 13.64c-32.1-18.08-54.3-37.51-67.9-56.33M269 997.37c-19.6-2.74-33.4-20.94-30.6-40.62 2.7-19.68 20.9-33.43 40.6-30.69 20.3 2.82 44.3 5.36 70.9 7.51 19.8 1.6 34.6 18.98 33 38.79-1.6 19.8-19 34.58-38.8 32.98-28.1-2.28-53.6-4.98-75.1-7.97m223.9 15.12c-19.8-.38-35.7-16.82-35.3-36.68.4-19.87 16.8-35.69 36.7-35.31 23.9.46 48.2.6 72.4.37 19.8-.18 36.1 15.8 36.3 35.67s-15.8 36.15-35.7 36.33c-24.9.23-49.8.09-74.4-.38m223.9-6.24c-19.8 1.72-37.3-12.94-39-32.74-1.8-19.79 12.9-37.26 32.7-38.99 25.1-2.19 48.7-4.97 70.3-8.45 19.6-3.17 38.1 10.19 41.2 29.8 3.2 19.61-10.1 38.11-29.8 41.28-23.1 3.74-48.5 6.75-75.4 9.1m228.1-90.2c-8.8 17.78-30.5 25.02-48.2 16.16-17.8-8.87-25.1-30.5-16.2-48.28 7.8-15.64 10.1-28.5 5-39.41-8.3-18.03-.5-39.45 17.5-47.81 18.1-8.36 39.5-.52 47.8 17.5 13 28.01 14.2 61.68-5.9 101.84M804.5 721.72c19.2 4.87 30.9 24.46 26 43.72-4.8 19.27-24.4 30.95-43.7 26.09-21.8-5.52-45-9.79-68.3-13.15-19.7-2.83-33.4-21.09-30.5-40.76 2.8-19.66 21-33.33 40.7-30.5 25.8 3.72 51.6 8.49 75.8 14.6m-226-26.93c19.9.66 35.5 17.32 34.8 37.18-.6 19.86-17.3 35.44-37.2 34.78-14-.47-26.2-.72-36.1-.89-19.8-.35-35.7-16.76-35.3-36.63.3-19.87 16.7-35.71 36.6-35.36 10.2.18 22.8.44 37.2.92" })
	]
});
export default SvgIconEraserLasso;
